import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="report-validation"
export default class extends Controller {
  static values = {
    maxDays: { type: Number, default: 120 }
  }

  validate(event) {
    // Ler valores diretamente dos campos de filtro do formulário de busca
    const clientField = document.querySelector('#q_client_id_eq')
    const dateStartField = document.querySelector('#q_activity_date_gteq')
    const dateEndField = document.querySelector('#q_activity_date_lteq')
    const userExternalIdField = document.querySelector('#q_user_external_id_cont')
    const cpfField = document.querySelector('#q_cpf_cont')
    const emailField = document.querySelector('#q_email_cont')

    const clientId = clientField?.value
    const dateStart = dateStartField?.value
    const dateEnd = dateEndField?.value

    // Verificar todos os campos primeiro
    // Se o campo cliente não existe no DOM (usuário é do tipo :client), o backend preenche automaticamente
    const missingClient = clientField ? (!clientId || clientId === '') : false
    const missingDateRange = !dateStart || !dateEnd

    // Se ambos estiverem faltando, mostrar mensagem combinada
    if (missingClient && missingDateRange) {
      event.preventDefault()
      alert(this.getTranslation('client_and_date_required'))
      return false
    }

    // Se apenas cliente estiver faltando
    if (missingClient) {
      event.preventDefault()
      alert(this.getTranslation('client_required'))
      return false
    }

    // Se apenas período estiver faltando
    if (missingDateRange) {
      event.preventDefault()
      alert(this.getTranslation('date_range_required'))
      return false
    }

    // Validar período máximo de 120 dias
    const start = new Date(dateStart)
    const end = new Date(dateEnd)
    const diffTime = Math.abs(end - start)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    if (diffDays > this.maxDaysValue) {
      event.preventDefault()
      const message = this.getTranslation('date_range_too_large')
        .replace('%{days}', diffDays)
        .replace('%{max_days}', this.maxDaysValue)
      alert(message)
      return false
    }

    // Validação passou - Agora adicionar filtros ao formulário dinamicamente
    this.addFiltersToForm(event.target, {
      client_id_eq: clientId,
      activity_date_gteq: dateStart,
      activity_date_lteq: dateEnd,
      user_external_id_cont: userExternalIdField?.value,
      cpf_cont: cpfField?.value,
      email_cont: emailField?.value
    })

    // Permite o submit
    return true
  }

  addFiltersToForm(form, filters) {
    // Remove hidden fields antigos que começam com q[
    form.querySelectorAll('input[name^="q["]').forEach(input => input.remove())

    // Adiciona novos hidden fields com os valores atuais dos filtros
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== '') {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = `q[${key}]`
        input.value = value
        form.appendChild(input)
      }
    })
  }

  getTranslation(key) {
    const locale = document.documentElement.lang || 'pt-BR'

    const translations = {
      'pt-BR': {
        client_and_date_required: 'Em "Filtros Avançados", é necessário:\n\n- Selecionar um cliente\n- Informar o período completo (data inicial e data final)\n\nPor favor, preencha os filtros antes de gerar o relatório.',
        client_required: 'Em "Filtros Avançados", selecione um cliente antes de gerar o relatório.',
        date_range_required: 'Em "Filtros Avançados", informe o período completo (data inicial e data final) antes de gerar o relatório.',
        date_range_too_large: 'O período selecionado é muito grande (%{days} dias). O máximo permitido é %{max_days} dias (4 meses). Por favor, reduza o intervalo de datas em "Filtros Avançados".'
      },
      'en': {
        client_and_date_required: 'In "Advanced Filters", it is necessary to:\n\n- Select a client\n- Inform the complete period (start date and end date)\n\nPlease fill in the filters before generating the report.',
        client_required: 'In "Advanced Filters", please select a client before generating the report.',
        date_range_required: 'In "Advanced Filters", please inform the complete period (start date and end date) before generating the report.',
        date_range_too_large: 'The selected period is too large (%{days} days). The maximum allowed is %{max_days} days (4 months). Please reduce the date range in "Advanced Filters".'
      }
    }

    return translations[locale]?.[key] || translations['pt-BR'][key]
  }
}
